import {Component, input} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {ContactFormModel} from './contact-form.model';
import {TranslatePipe} from '@ngx-translate/core';
import {Label} from '../../../../components/label/label';
import {TextInput} from '../../../../components/text-input/text-input';
import {AddressForm} from '../address-form/address-form';
import {ToggleSwitch} from '../../../../components/toggle-switch/toggle-switch';
import {Editor} from '../../../../components/editor/editor';
import {PartyDropdown} from '../../../../components/party-dropdown/party-dropdown';
import {LegalEntityDropdown} from '../../../finances/components/legal-entity-dropdown/legal-entity-dropdown';
import {LocalDropdown} from '../../../../components/local-dropdown/local-dropdown';
import {PartyType} from '../../../../../api';

@Component({
  selector: 'elcia-contact-form',
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
    Label,
    TextInput,
    AddressForm,
    ToggleSwitch,
    Editor,
    PartyDropdown,
    LegalEntityDropdown,
    LocalDropdown
  ],
  templateUrl: './contact-form.html',
  styleUrl: './contact-form.scss',
})

export class ContactForm {

  form = input.required<FormGroup<ContactFormModel>>();

  protected readonly companyPartyTypes = [PartyType.Company];

}
